import _extends from "@babel/runtime/helpers/esm/extends";
import { fieldsIBaseModelWithUser } from './base';
import { EModel } from './model';

/**
 * Represents an external ID for an assistant instance.
 */

/**
 * Enum for defining accuracy levels.
 */
export let EAccuracy;

/**
 * Enum representing the status of the assistant instance.
 */
(function (EAccuracy) {
  EAccuracy["Good"] = "good";
  EAccuracy["Low"] = "low";
  EAccuracy["Fair"] = "fair";
})(EAccuracy || (EAccuracy = {}));
export let EAssistantInstanceStatus;

/**
 * Enum representing the reason for the assistant instance's status.
 */
(function (EAssistantInstanceStatus) {
  EAssistantInstanceStatus["Idle"] = "idle";
  EAssistantInstanceStatus["InProgress"] = "in-progress";
  EAssistantInstanceStatus["Failure"] = "failure";
  EAssistantInstanceStatus["Success"] = "success";
})(EAssistantInstanceStatus || (EAssistantInstanceStatus = {}));
export let EAssistantInstanceStatusReason;

/**
 * Represents the entry point for an assistant instance.
 */
(function (EAssistantInstanceStatusReason) {
  EAssistantInstanceStatusReason["SuccessByAssistant"] = "success-by-assistant";
  EAssistantInstanceStatusReason["SuccessByTransfer"] = "success-by-transfer";
  EAssistantInstanceStatusReason["SuccessByPatient"] = "success-by-patient";
  EAssistantInstanceStatusReason["SuccessByStaff"] = "success-by-staff";
  EAssistantInstanceStatusReason["SuccessByAssistantTimeout"] = "success-by-assistant-timeout";
  EAssistantInstanceStatusReason["FailureByAssistant"] = "failure-by-assistant";
  EAssistantInstanceStatusReason["FailureByPatient"] = "failure-by-patient";
  EAssistantInstanceStatusReason["FailureByStaff"] = "failure-by-staff";
  EAssistantInstanceStatusReason["IncompleteSuccessCriteria"] = "incomplete-success-criteria";
  EAssistantInstanceStatusReason["TimedOut"] = "timed-out";
  EAssistantInstanceStatusReason["NoNewMessages"] = "no-new-messages";
  EAssistantInstanceStatusReason["MaximumRetries"] = "maximum-retries";
})(EAssistantInstanceStatusReason || (EAssistantInstanceStatusReason = {}));
/**
 * Represents the external status of an assistant instance.
 */
/**
 * Interface for the assistant instance.
 */
export const fieldsAssistantInstance = _extends({}, fieldsIBaseModelWithUser, {
  allPatientMatches: {
    type: 'ID',
    ref: EModel.Patient,
    array: true
  },
  analysis: {
    type: 'Object'
  },
  assistant: {
    type: 'ID',
    ref: EModel.Assistant
  },
  entryPoints: {
    type: 'Object',
    array: true
  },
  externalStatus: {
    type: 'Object'
  },
  fakePatient: {
    type: 'Boolean'
  },
  onBehalfOf: {
    type: 'ID',
    ref: EModel.Patient
  },
  patient: {
    type: 'ID',
    ref: EModel.Patient
  },
  status: {
    type: 'Option',
    values: EAssistantInstanceStatus
  },
  statusReason: {
    type: 'Option',
    values: EAssistantInstanceStatusReason
  },
  statusUpdatedAt: {
    type: 'Date'
  },
  verified: {
    type: 'Boolean'
  },
  verifiedContactValue: {
    type: 'Text'
  }
});